import styled from 'styled-components';

export default tag => (...styles) => {
  let importantStyles = styles[0].map((s, i, arr) => {
    // add !important to each css property
    let importantStyle = s.replace(/;/g, ' !important;');

    // wrap styles in cleanslate parent selector to apply correct level of specificity
    if (i === 0) {
      importantStyle = `.cleanslate & { ${importantStyle}`;
    }
    if (i === arr.length - 1) {
      importantStyle = `${importantStyle} }`;
    }

    return importantStyle;
  });
  return styled(tag)(importantStyles, ...styles.slice(1));
};
